// Routing hint only: the server still verifies the token's signature.
export function reusableMaxToken(token, platform, maxUserId, now = Date.now()) {
    if (platform !== 'max' || typeof token !== 'string') return null;
    try {
        const encoded = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        const payload = JSON.parse(atob(encoded.padEnd(Math.ceil(encoded.length / 4) * 4, '=')));
        return payload.platform === 'max' && String(payload.user_id) === String(maxUserId)
            && Number(payload.exp) * 1000 > now + 30000 ? token : null;
    } catch { return null; }
}
